import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQueryParametersAction } from "../actions";
import { getRows, getLoading, getDateFormat } from "../selectors";
import { CLEAR_STATE } from "../actionTypes";
import { getIsExportingGrid } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import CommonPage from "@icarius-common/commonPage";
import paths from "@icarius-router/paths";
import FormContainer from "./form/formContainer";
import ConfirmationDialog from "./dialogs/confirmationDialog";
import DuplicateDialog from "./dialogs/duplicateDialog";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import useABM from "./useABM";

const GeoQueryDefinitionParameters = ({ parameter, handleGoBack }) => {
    const dispatch = useDispatch();

    const data = useSelector(getRows);
    const dateFormat = useSelector(getDateFormat);
    const isLoading = useSelector(getLoading);
    const isExportinGrid = useSelector(getIsExportingGrid);

    useEffect(() => {
        dispatch(getQueryParametersAction(parameter.code));
        return () => {
            dispatch({ type: CLEAR_STATE });
        };
    }, [dispatch, parameter.code]);

    const {
        deleteDialogIsOpen,
        createEditDialogIsOpen,
        duplicateDialogIsOpen,
        selectedItem,
        handleOpenCreateDialog,
        handleOpenEditDialog,
        handleCloseEditDialog,
        handleOpenDeleteDialog,
        handleCloseDeleteDialog,
        handleOpenDuplicateDialog,
        handleCloseDuplicateDialog,
        handleDelete,
        handleDuplicate,
    } = useABM();

    const goBackItem = () => (
        <CustomIconButton title={getLocalizedString("goBack")} onClick={handleGoBack} type={"goBack"} />
    );

    const addItem = () => (
        <CustomIconButton title={getLocalizedString("create")} onClick={() => handleOpenCreateDialog()} type={"add"} />
    );

    const deleteItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("delete")}
            onClick={() => handleOpenDeleteDialog(gridRef)}
            type={"delete"}
        />
    );

    const editItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("edit")}
            onClick={() => handleOpenEditDialog(gridRef)}
            type={"edit"}
        />
    );

    const duplicateItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("duplicate")}
            onClick={() => handleOpenDuplicateDialog(gridRef)}
            type={"duplicate"}
        />
    );

    return (
        <>
            {Boolean(createEditDialogIsOpen) ? (
                <FormContainer
                    isLoading={isLoading}
                    data={selectedItem}
                    paramNumToUse={data.length + 1}
                    parameterCode={parameter.code}
                    handleClose={handleCloseEditDialog}
                />
            ) : (
                <CommonPage
                    columnDefPage={paths.geoQueryParameters}
                    title={`${getLocalizedString("geoanalysisParameters")}: ${parameter.name} - ${parameter.code}`}
                    gridTitle={`${getLocalizedString("geoanalysisParameters")}: ${parameter.name} - ${parameter.code}`}
                    menuItems={[goBackItem, addItem, editItem, deleteItem, duplicateItem]}
                    rowData={data}
                    dateFormat={dateFormat}
                    isLoading={isExportinGrid || isLoading}
                    hasExpand
                    hasHelp
                >
                    {deleteDialogIsOpen && !isLoading && (
                        <ConfirmationDialog
                            open={deleteDialogIsOpen}
                            title={getLocalizedString("atention")}
                            text={getLocalizedString("areYouSureYouWantToDeleteTheParameter")}
                            handleConfirm={handleDelete}
                            handleClose={handleCloseDeleteDialog}
                        />
                    )}
                    {duplicateDialogIsOpen && !isLoading && (
                        <DuplicateDialog
                            open={duplicateDialogIsOpen}
                            data={selectedItem}
                            paramNumToUse={data.length + 1}
                            handleConfirm={handleDuplicate}
                            handleClose={handleCloseDuplicateDialog}
                        />
                    )}
                </CommonPage>
            )}
        </>
    );
};

export default GeoQueryDefinitionParameters;
